import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SuperToolLogo from './SuperToolLogo';

const Header = ({ onScrollTo }) => {
  const navigate = useNavigate();

  const handleNav = (section) => {
    if (onScrollTo) {
      onScrollTo(section);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
          <SuperToolLogo size={32} animated={false} />
          <span className="text-lg font-bold text-gray-900">SuperTool AI</span>
        </div>

        {/* Center Nav */}
        <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
          <button onClick={() => handleNav('features')} className="text-sm text-gray-600 hover:text-gray-900 transition-colors font-medium" data-testid="nav-features">
            Features
          </button>
          <button onClick={() => handleNav('pricing')} className="text-sm text-gray-600 hover:text-gray-900 transition-colors font-medium" data-testid="nav-pricing">
            Pricing
          </button>
          <button onClick={() => handleNav('faq')} className="text-sm text-gray-600 hover:text-gray-900 transition-colors font-medium" data-testid="nav-faq">
            FAQs
          </button>
          <button onClick={() => handleNav('enterprise')} className="text-sm text-gray-600 hover:text-gray-900 transition-colors font-medium" data-testid="nav-enterprise">
            Enterprise
          </button>
        </nav>

        {/* CTA */}
        <button
          onClick={() => handleNav('auth')}
          className="flex items-center gap-2 bg-white text-[#000000] px-5 py-2.5 rounded-full font-semibold text-sm hover:bg-slate-100 transition-all shadow-lg shadow-white/10"
          data-testid="header-get-started"
        >
          Get Started
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </header>
  );
};

export default Header;
